import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useBreakpoint } from '~/techstyle-shared/react-components';

const StyledProductName = styled.p`
  display: block;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  margin-bottom: 6px;
  color: ${({ theme }) => theme.colors.gridProductCardProductNameTextColor};
  ${({ theme }) => theme.gridCellStyles.productName}
`;

const PricingVariantName = styled.p`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;

  overflow: hidden;
  color: ${({ theme }) => theme.colors.pricingUiTestBoldLabel};
  text-overflow: ellipsis;
  font-family: ${({ theme }) => theme.fontStacks.standardGtPressuraFamily};
  font-size: ${({ $isMobile }) => ($isMobile ? '12px' : '14px')};
  font-style: normal;
  font-weight: 350;
  line-height: 16px; /* 114.286% */
  padding-top: 4px;
`;

function ProductName({
  children,
  isUnavailable = false,
  isNewPricingUiEnabled,
}) {
  const { isMobile } = useBreakpoint();

  if (isNewPricingUiEnabled) {
    return (
      <PricingVariantName
        isUnavailable={isUnavailable}
        data-qa-automation="gridSetsProdName"
        data-autotag="grid-product-name"
        $isMobile={isMobile}
      >
        {children}
      </PricingVariantName>
    );
  }
  return (
    <StyledProductName
      isUnavailable={isUnavailable}
      data-qa-automation="gridSetsProdName"
      data-autotag="grid-product-name"
    >
      {children}
    </StyledProductName>
  );
}

ProductName.propTypes = {
  children: PropTypes.node.isRequired,
  isNewPricingUiEnabled: PropTypes.bool,
  isUnavailable: PropTypes.bool,
};

export default ProductName;
